module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/service-842f46830ff0e5772e05917ff260b870.webp";